import * as React from "react";
import type { SVGProps } from "react";
const SvgBellOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M20.673 17.029c-.62-.912-1.22-2.255-1.22-3.874l.026-2.216c0-4.395-3.324-7.957-7.425-7.957q-.662.001-1.293.122m5.366 15.005H3.88c-.46 0-.717-.707-.439-1.1.646-.91 1.269-2.246 1.269-3.854l.026-2.331c0-1.87.61-3.586 1.629-4.933M9.146 21.6h5.817m3.491-.582L5.072 2.4"
    />
  </svg>
);
export default SvgBellOff02;
